import React, {useEffect, useState} from "react"
import {
    Badge,
    Button,
    Col,
    Container,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalFooter,
    Row,
} from "reactstrap"
import Image from "../../components/CustomImage"
import USER from "../../graphql/queries/user";
import USER_WITH_PRICING from "../../graphql/queries/userWithPricing";
import {useQuery} from "@apollo/react-hooks";
import withApollo from "../../lib/withApollo";
import {getDataFromTree} from "@apollo/react-ssr";
import {getSessionId} from "../../services/session";
import moment from "moment";
import RemoveFromCartButton from "../../components/Button/RemoveFromCartButton";
import {getImageUrl} from "../../services/image";
import RemoveCamperFromCartButton from "../../components/Button/RemoveCamperFromCartButton";
import {useRouter} from "next/router";
import Link from "next/link";
import {useLazyQuery} from "@apollo/client";
import ModalHeader from "../../components/Modal/ModalHeader";
import dynamic from "next/dynamic";
import LargeScreenComponent from "../../components/LargeScreenComponent";

let Swiper = dynamic(
    () => import("react-id-swiper"),
    {ssr: false}
);

const swiperParams = {
    pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    }
}

const Cart = () => {
    const router = useRouter();
    const uuid = getSessionId();
    const [user, setUser] = useState(null);
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const [getUserWithPricing] = useLazyQuery(USER_WITH_PRICING, {
        fetchPolicy: 'network-only',
        onCompleted: (data) => setUser(data.user)
    });

    const {loading, error, data} = useQuery(USER, {
        variables: {
            uuid: uuid
        },
    });

    useEffect(() => {
        if (data && data.user) {
            setUser(data.user);
            getUserWithPricing({
                variables: {
                    uuid: uuid
                }
            });
        }
    }, [data]);

    if (loading) {
        <div>Gegevens aan het ophalen</div>
    }

    return (
        <>
            <section className="py-5">
                <Container>
                    <div className="d-flex justify-content-between align-items-end mb-3 mb-lg-4">
                        <h1 className="hero-heading mb-0">Uw winkelwagen</h1>
                    </div>
                    <div>
                        <div className="mb-3 mb-lg-5">
                            {user &&
                                <p className="mb-0 mb-lg-0">
                                    <Row>
                                        <Col lg="8" className="mb-2">
                                            U bent slechts één stap verwijderd van de basis voor een prachtige vakantie.
                                        </Col>
                                        <Col lg="4" className="text-right">
                                            <LargeScreenComponent>
                                            {user && user.cart.hasUnavailableItems === false &&
                                                <Link href="/winkelwagen/afrekenen">
                                                    <Button
                                                        disabled={user.cart.hasUnavailableItems !== false}
                                                        color="primary"
                                                    >
                                                        Verder naar bevestigen
                                                    </Button>
                                                </Link>
                                            }
                                            </LargeScreenComponent>
                                        </Col>
                                    </Row>
                                </p>
                            }
                        </div>
                    </div>

                    {user && user.cart.hasUnavailableItems &&
                        <div className="alert alert-primary" role="alert">
                            Een of meerdere artikelen in uw winkelwagen zijn niet meer beschikbaar.
                            Verwijder deze artikelen om verder te kunnen gaan met uw bestelling.
                        </div>
                    }

                    {user && user.cart.cottageStays.length > 0 &&
                        <>
                            <h2>Cottages</h2>
                            <ListGroup className="shadow mb-5">
                                {user && user.cart.cottageStays.map((cottageStay) => (
                                    <ListGroupItem
                                        // onClick={() => {
                                        //   router.push({
                                        //     pathname: `/vakantiehuizen/${cottageStay.cottage.slug}`,
                                        //   })
                                        // }}
                                        action className="py-4" key={cottageStay.id}>
                                        <Row>
                                            <Col lg="3" className="">
                                                <Swiper {...swiperParams}>
                                                    {cottageStay.cottage.images.map((image, index) => (
                                                        <div key={image.url}>
                                                            <Link
                                                                prefetch={false}
                                                                href={{
                                                                    pathname: '/vakantiehuizen/[slug]',
                                                                }}
                                                                as={{
                                                                    pathname: `/vakantiehuizen/${cottageStay.cottage.slug}`,
                                                                }}
                                                                passHref
                                                            >
                                                                <a aria-label="Ga naar cottage details">
                                                                    <div>
                                                                        <Image
                                                                            placeholder="blur"
                                                                            blurDataURL={getImageUrl('image-loader2.jpeg')}
                                                                            src={`${image.url}`}
                                                                            alt={`Vakantiehuis in ${cottageStay.cottage.name}`}
                                                                            height={150}
                                                                            width={225}
                                                                            layout="responsive"
                                                                            className="img-fluid rounded"
                                                                            sizes="(max-width:576px) 100vw, (max-width:991px) 50vw, (max-width:1199px) 30vw, 20vw"
                                                                        />
                                                                    </div>
                                                                </a>
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </Swiper>
                                            </Col>
                                            <Col lg="1" className="mt-4">
                                            </Col>
                                            <Col lg="4" className="">
                                                <div className="d-flex align-items-center mb-3">
                                                    <h2 className="h5 mb-0">{cottageStay.cottage.name}</h2>
                                                </div>
                                                <span className="font-weight-bold text-sm mb-1">Code: {cottageStay.cottage.internalCode}</span>
                                                {cottageStay.cottage.tags && (
                                                    <ul className="list-inline text-sm mb-4">
                                                        {cottageStay.cottage.tags.map((tag) => (
                                                            <li key={tag.value} className="list-inline-item mr-3">
                                                                <i
                                                                    className={`fa fa-${tag.icon} mr-1 text-secondary`}
                                                                />{" "}
                                                                {tag.value}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                                {/*<p className="text-sm text-muted">{booking.type}</p>*/}
                                                <Badge
                                                    color="primary"
                                                    className="p-2"
                                                    pill
                                                >
                                                    {/*{moment(cottageStay.startDate).format('D MMM Y')} - {moment(cottageStay.endDate).format('D MMM Y')}*/}
                                                </Badge>
                                                {cottageStay.cottage.petsAllowed &&
                                                    <div className="my-2 text-sm"><i className="fas fa-paw text-secondary"/> Extra per hond € 25,-<br/>
                                                        Wordt verrekend tijdens het boeken.
                                                    </div>
                                                }
                                            </Col>
                                            <Col lg="2">
                                                <Row>
                                                    <Col className="">
                                                        <h6 className="label-heading">Aankomst datum</h6>
                                                        <p className="text-sm font-weight-bold">
                                                            {moment(cottageStay.startDate).format('D MMM Y')}
                                                        </p>
                                                        <h6 className="label-heading">Vertrek datum</h6>
                                                        <p className="text-sm font-weight-bold">
                                                            {moment(cottageStay.endDate).format('D MMM Y')}
                                                        </p>
                                                        <h6 className="label-heading">Nachten</h6>
                                                        <p className="text-sm font-weight-bold mb-0">
                                                            {moment(cottageStay.endDate).diff(moment(cottageStay.startDate), 'days')} nachten
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col lg="2" className="text-right">
                                                <Row>
                                                    <Col>
                                                        <h6 className="label-heading">Prijs</h6>
                                                        <p className="text-sm font-weight-bold">
                                                            {cottageStay.price
                                                                ?
                                                                <>
                                                                    € {cottageStay.price}
                                                                </>
                                                                :
                                                                <>
                                                                    Niet meer beschikbaar
                                                                </>
                                                            }
                                                        </p>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <h6 className="label-heading">Aanbetaling</h6>
                                                        <p className="text-sm font-weight-bold">
                                                            {cottageStay.priceToPayDirect &&
                                                                <>
                                                                    € {cottageStay.priceToPayDirect}
                                                                </>
                                                            }
                                                        </p>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Link href={`/vakantiehuizen/${cottageStay.cottage.slug}`}>
                                                            <Button color="primary">Bekijk Cottage</Button>
                                                        </Link>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="text-align-end mt-4">
                                                <RemoveFromCartButton
                                                    onClick={() => {
                                                        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                                                        toggle()
                                                    }}
                                                    stayId={cottageStay.id}
                                                />
                                            </Col>
                                        </Row>
                                    </ListGroupItem>
                                ))}
                            </ListGroup>
                        </>
                    }

                    {user && user.cart.camperTrips.length > 0 &&
                        <>
                            <h2>Campers</h2>
                            <ListGroup className="shadow mb-5">
                                {user && user.cart.camperTrips.map((camperTrip) => (
                                    <ListGroupItem
                                        // onClick={() => (
                                        //     router.push({
                                        //       pathname: `/camper/type/${camperTrip.camper.seoId}`,
                                        //       query: {
                                        //         ophaallocatie: camperTrip.pickupLocation,
                                        //         afleverlocatie: camperTrip.dropOffLocation,
                                        //         ophaaldatum: camperTrip.pickupDate,
                                        //         afleverdatum: camperTrip.dropOffDate,
                                        //       }
                                        //     })
                                        // )}
                                        action className="py-4" tag="a" key={camperTrip.id}>
                                        <Row>
                                            <Col lg="3" className="">
                                                <Image
                                                    src={getImageUrl(camperTrip.camper.thumbnail)}
                                                    alt={camperTrip.camper.type}
                                                    height={150}
                                                    width={225}
                                                    layout="responsive"
                                                />
                                            </Col>
                                            <Col lg="1" className="mt-4">
                                            </Col>
                                            <Col lg="4" className="">
                                                <div className="d-flex align-items-center mb-3">
                                                    <h2 className="h5 mb-0">{camperTrip.camper.type}</h2>
                                                </div>
                                                {camperTrip.options && JSON.parse(camperTrip.options).length > 0 && (
                                                    <>
                                                        <h6>Verzekering:</h6>
                                                        <ul className="list-inline text-sm mb-4">
                                                            <li className="list-inline-item mr-3">
                                                                {JSON.parse(camperTrip.insuranceOption).name} (€{JSON.parse(camperTrip.insuranceOption).totalAmountEuro})
                                                            </li>
                                                        </ul>
                                                    </>
                                                )}
                                                {camperTrip.options && JSON.parse(camperTrip.options).length > 0 && (
                                                    <>
                                                        <h6>Extra opties:</h6>
                                                        <ul className="list-inline text-sm mb-4">
                                                            {JSON.parse(camperTrip.options).map((option, index) => (
                                                                <li key={index} className="list-inline-item mr-3">
                                                                    {option.name} (€{option.totalFeeEuro})
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </>
                                                )}
                                                <Badge
                                                    color="primary"
                                                    className="p-2"
                                                    pill
                                                >
                                                </Badge>
                                            </Col>
                                            <Col lg="2">
                                                <Row>
                                                    <Col className="">
                                                        <h6 className="label-heading">Aankomst datum</h6>
                                                        <p className="text-sm font-weight-bold">
                                                            {moment(camperTrip.pickupDate).format('D MMM Y')}
                                                        </p>
                                                        <h6 className="label-heading">Vertrek datum</h6>
                                                        <p className="text-sm font-weight-bold">
                                                            {moment(camperTrip.dropOffDate).format('D MMM Y')}
                                                        </p>
                                                        <h6 className="label-heading">Dagen</h6>
                                                        <p className="text-sm font-weight-bold mb-0">
                                                            {moment(camperTrip.dropOffDate).diff(moment(camperTrip.pickupDate), 'days') + 1} dagen
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col lg="2" className="text-right">
                                                <Row>
                                                    <Col>
                                                        <h6 className="label-heading">Prijs</h6>
                                                        <p className="text-sm font-weight-bold checkout-camper-price">
                                                            {camperTrip.price !== undefined
                                                                ? <>{!camperTrip.available ? 'Niet meer beschikbaar' : `€ ${camperTrip.price}`}</>
                                                                : <span className="loader-small"></span>
                                                            }
                                                        </p>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <h6 className="label-heading">Aanbetaling</h6>
                                                        <p className="text-sm font-weight-bold checkout-camper-price">
                                                            {camperTrip.priceToPayDirect !== undefined
                                                                ? <>{camperTrip.available && `€ ${camperTrip.priceToPayDirect}`}</>
                                                                : <span className="loader-small"></span>
                                                            }
                                                        </p>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <RemoveCamperFromCartButton tripId={camperTrip.id}/>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </ListGroupItem>
                                ))}
                            </ListGroup>
                        </>
                    }

                    {user && user.cart.hasUnavailableItems &&
                        <div className="alert alert-primary" role="alert">
                            Een of meerdere artikelen in uw winkelwagen zijn niet meer beschikbaar.
                            Verwijder deze artikelen om verder te kunnen gaan met uw bestelling.
                        </div>
                    }

                    {user && user.cart.productCount > 0 &&
                        <ListGroup className="mb-5">
                            <Row>
                                <Col lg="8">
                                </Col>
                                <Col lg="4" className="text-right font-weight-bold">
                                    <Row>
                                        <Col className="checkout-camper-price">
                                            {user && user.cart.totalPrice
                                                ? <>
                                                    Totaal prijs € {user.cart.totalPrice}<br/>
                                                    Direct te voldoen € {user.cart.priceToPayDirect}<br/>
                                                </>
                                                : <>
                                                    <div className="loader-small"></div>
                                                    Totaal prijs </>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="mt-2">
                                            <Link href="/winkelwagen/afrekenen">
                                                <Button
                                                    disabled={user.cart.hasUnavailableItems !== false}
                                                    color="primary"
                                                >
                                                    Verder naar bevestigen
                                                </Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </ListGroup>
                    }

                    {user && user.cart.productCount > 0 &&
                        <>
                            {user.cart.isSTOGarantApplicable ?
                                <Row>
                                    <Col lg="1">
                                        <Link href="https://www.sto-garant.nl" passHref>
                                            <a>
                                                <Image
                                                    src={getImageUrl('logo-garant.png')}
                                                    className="bg-image" alt="STO Garant logo"
                                                    height={75}
                                                    width={75}
                                                />
                                            </a>
                                        </Link>
                                    </Col>
                                    <Col lg="11" className="text-sm align-self-center">
                                        Dit aanbod valt onder de garantie van STO Garant. U kunt de voorwaarden van deze
                                        garantieregeling vinden op de website van STO Garant
                                        (www.sto-garant.nl/downloads).
                                    </Col>
                                </Row>
                                :
                                <Row>
                                    {/*<Col lg="12" className="text-sm">*/}
                                    {/*    Een pakketreis valt verplicht onder de garantieregeling. Bij reservering van een*/}
                                    {/*    enkele*/}
                                    {/*    reisdienst (bijv. 1 of meerdere vakantiehuizen) is deze garantieregeling niet*/}
                                    {/*    verplicht.<br/>*/}
                                    {/*    Deze boeking valt niet onder de garantie van STO Garant. U kunt de voorwaarden*/}
                                    {/*    van deze*/}
                                    {/*    garantieregeling vinden op www.sto-garant.nl/downloads.*/}
                                    {/*</Col>*/}
                                </Row>
                            }
                        </>
                    }

                    <Row>
                        <Col className="text-right">
                            <span>
                                <Image
                                    src={getImageUrl('iDEAL_RGB_2020_v1_large.png')}
                                    alt={"ideal"}
                                    layout="fixed"
                                    width="28px"
                                    height="25px"
                                />
                            </span>

                            <span className="ml-4">
                                <Image
                                    src={getImageUrl('mc_acc_opt_70_3x.png')}
                                    alt={"ideal"}
                                    layout="fixed"
                                    width="40px"
                                    height="25px"
                                />
                            </span>
                            <span className="ml-4">
                                <Image
                                    src={getImageUrl('visa_pos_fc.png')}
                                    alt={"ideal"}
                                    layout="fixed"
                                    width="40px"
                                    height="25px"
                                />
                            </span>
                            <span className="ml-4">
                                <Image
                                    src={getImageUrl('vpay_blu01.png')}
                                    alt={"ideal"}
                                    layout="fixed"
                                    width="31px"
                                    height="25px"
                                />
                            </span>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Modal isOpen={modal} toggle={toggle} centered={true} fade={false} backdropClassName="desktop-backdrop"
                   contentClassName="modal-border">
                <ModalHeader toggle={toggle}>
                    <h5>De cottage is verwijderd uit uw winkelwagen</h5>
                </ModalHeader>
                <ModalFooter>
                    <Button color="primary" onClick={toggle}>Ok</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

Cart.getInitialProps = async () => {
    return {
        nav: {
            light: true,
            classes: "shadow",
            color: "white",
        },
        title: "Winkelwagen - Cottage Centre",
    };
};

export default withApollo(Cart, {getDataFromTree});
